const getAllStudiosResponse = (response) => {
  return response?.data?.studios.map((studio) => {
    return {
      value: studio?.id,
      label: `${studio?.name}`,
      labelDescription: studio?.area?.name ?? '-',
    };
  });
};

export default getAllStudiosResponse;
